<template>
  <div>
    <Spinner
      :isLoading="isLoading"
      :error="error"
      :textLoading="textLoading"
      :textError="textError"
      :textLoaded="textLoaded"
    ></Spinner>
  </div>
  <div ref="asyncHtmlElem" v-html="asyncHtml"></div>
</template>

<script>
import Accordion from "common/js/script/accordion";
import AncorNavigation from "common/js/script/ancorNavigation";
import LaddaPartialViewMedAjaxService from "../plugins/laddapartialviewmedajaxService";
import loadview from "common/js/script/loadview";
import Spinner from "common/js/vue/helpers/spinner.vue";

export default {
  name: "LaddaPartialViewMedAjax",
  props: {
    data: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    textLoading: {
      type: String,
      required: true,
    },
    textError: {
      type: String,
      required: true,
    },
    textLoaded: {
      type: String,
      required: true,
    },
  },
  components: {
    Spinner,
  },
  data: function () {
    return {
      error: false,
      isLoading: false,
      asyncHtml: null,
    };
  },
  created() {
    this.isLoading = true;
    LaddaPartialViewMedAjaxService.hamtaPartial(this.apiUrl, this.data)
      .then((result) => {
        if (result && result.status === 200) {
          this.asyncHtml = result.data;
        }
      })
      .catch((err) => {
        console.log(err);
        this.error = true;
      })
      .finally(() => {
        this.isLoading = false;
        if (this.asyncHtml != null) {
          var asyncHtmlElem = this.$refs.asyncHtmlElem;
          if (asyncHtmlElem) {
            Accordion.updateAccordion(asyncHtmlElem);
            AncorNavigation.updateScript(asyncHtmlElem);
            loadview.updateObserveAttibute();
          }
        }
      });
  },
};
</script>
